export const ADD_NOTIFICATION_USERS_MUTATION = `
    mutation AddNotificationUsers($project_id: Int!, $user_ids: [Int!]!, $type_id: Int) {
        addNotificationUsers(project_id: $project_id, user_ids: $user_ids, type_id: $type_id)
    }
`;

export const UPDATE_NOTIFICATION_USERS_MUTATION = `
    mutation UpdateNotificationUsers($project_id: Int!, $user_ids: [Int!]!, $type_id: Int) {
        updateNotificationUsers(project_id: $project_id, user_ids: $user_ids, type_id: $type_id)
    }
`;
